import { GzDropdownWebComponent } from './component/GzDropdownWebComponent';
import { WEB_COMPONENT_GZ_DROPDOWN } from '../../webcomponents.constants';

export { GzDropdownWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_DROPDOWN, GzDropdownWebComponent);
